import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { combineLatest } from 'rxjs'
import { AppSettingService, UserPracticesService } from '../api/services'
import { AuthService } from '../api/services/auth.service'
import { CareFinitySession } from '../carefinity/services/CareFinitySession'
import { environment } from '../../environments/environment'

@Component({
  selector: 'app-mfa',
  templateUrl: './app.mfa.component.html',
})
export class AppMFAComponent implements OnInit {
  private key: string
  private previousNavigation: string

    public displaypopup: boolean = false
    public displaypopupMFACreate: boolean = false;
    public displaypopupMFALogin: boolean = false;
  public title: string = ''
    authkey = ''

    version: string = '';
  constructor(
    private appSettingsService: AppSettingService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userPracticesService: UserPracticesService,
  ) {
    this.previousNavigation = this.router
      .getCurrentNavigation()
      .previousNavigation?.finalUrl?.toString()

    if (!this.previousNavigation) {
      this.router.navigate(['/'])
    }
    this.key = this.router.getCurrentNavigation().extras.state?.key

    if (this.key) {
      debugger
      this.selectedViewIndex = 2
      this.title = 'Your account has MFA enabled'
    } else {
      this.authService.authGetMfaAppSetup().subscribe(
        (item) => {
          if (item.setup) {
              this.selectedViewIndex = 1
              this.displaypopupMFACreate = true;
              this.displaypopupMFALogin = false;
            this.qr = item.qrCode
            this.authkey = item.key
            this.title = 'Setup Multi-Factor Authentication (MFA)'
          } else {
              this.selectedViewIndex = 2
              this.displaypopupMFACreate = false;
              this.displaypopupMFALogin = true;
            this.title = 'Your account has MFA enabled'
          }
        },
        (err) => {
          this.errorMessage = 'We are unable to prepare MFA.'
          this.showError = true
        },
      )
    }
  }

  selectedViewIndex = 1
  qr = ''
  authCode = ''
  showError = false
  errorMessage = ''

    ngOnInit() {
        this.version = environment.version;
    this.displaypopup = true
  }

  btnValidateAppAuthCode_Click() {
    this.showError = false
    const data = this.activatedRoute.snapshot.data
    //when user accesses mfa from forgot password page
    if (this.previousNavigation.indexOf('Patient/Forgot-Password') !== -1) {
      const username = this.activatedRoute.snapshot.queryParams.u_Name

      this.authService
        .authValidateAuthAppCodeWithoutLogin$Response({
          authCode: this.authCode,
          username,
        })
        .subscribe({
          next: (res) => {
            if (CareFinitySession.applicationSettings.isEmergencyTokenEnabled) {
              this.router.navigate(['Validate-token'], {
                state: {},
                queryParams: { u_Name: username },
              })
            } else {
              this.router.navigate(['Forgotpwd-change'], {
                state: {},
                queryParams: { u_Name: username },
              })
            }
          },
          error: (err) => {
            console.error('Error validating auth code without login', err)
            this.showError = true
            this.errorMessage = 'Invalid code specified'
          },
        })
    } else {
      this.authService
        .authValidateAuthAppCode$Response({ authCode: this.authCode })
        .subscribe({
          next: (res) => {
            combineLatest([
              this.userPracticesService.userPracticesGetAllPracticesOfUser(),
              this.authService.authAreAllQuestionsAnswered$Response(),
            ]).subscribe({
              next: ([practices, questionAnswered]) => {
                localStorage.setItem(
                  'user_practices',
                  JSON.stringify(practices),
                )

                if (questionAnswered.body < 3) {
                  this.router.navigate(['Patient/answer_questions'])
                  return
                }

                if (CareFinitySession.user.forcePasswordChange) {
                  this.router.navigate(['force-reset-password'], {
                    state: {
                      queryParams: { u_Name: CareFinitySession.user.userName },
                    },
                  })
                  return
                }

                this.router.navigate(['select-practice'])
              },
              error: (err) => {
                console.error(
                  'Error fetching practices or questions answered status',
                  err,
                )
                this.showError = true
                this.errorMessage =
                  'An error occurred while processing your request. Please try again later.'
              },
            })
          },
          error: (err) => {
            console.error('Invalid authentication code', err)
            this.showError = true
            this.errorMessage = 'Invalid code specified'
          },
        })
    }
  }
}
